module.exports = __webpack_public_path__ + "img/alert.e14bcb30.svg";